import React, { useState } from 'react';
import InlineSelect from '@components/atoms/inline-select/inline-select';
import { ListingContext } from '@context/listing.context';
import { useContextSelector } from 'use-context-selector';
import { useTranslation } from 'next-i18next';
import useWindowSize from '@hooks/use-window-size';
import styles from '../index.module.scss';
import UniversesMenu from './universes-menu';

const UniversesSelect: React.FC = () => {
  const { t } = useTranslation('pricing-calculator');
  const { isWiderThanMd } = useWindowSize();
  const { listingDraftPayload, setPricingCalculatorInputTouched, setShowDefaultPricingCalculatorMessage } =
    useContextSelector(ListingContext, (state) => state);

  const [closeMenu, setCloseMenu] = useState<boolean>(false);

  const DROPDOWN_HEIGHT = isWiderThanMd ? 200 : 162;
  const selectedUniverseId = listingDraftPayload?.universe;
  const universesLabel = {
    '1': t('PRICING_CALCULATOR.UNIVERSES.WOMEN'),
    '2': t('PRICING_CALCULATOR.UNIVERSES.MEN'),
    '3': t('PRICING_CALCULATOR.UNIVERSES.GIRLS'),
    '4': t('PRICING_CALCULATOR.UNIVERSES.BOYS'),
  };

  return (
    <div className={styles.formSentence__text}>
      <InlineSelect
        selectedItemLabel={universesLabel[selectedUniverseId]}
        containerPosition="static"
        dropdownHeight={DROPDOWN_HEIGHT}
        setIsTouched={setPricingCalculatorInputTouched}
        setMessageState={setShowDefaultPricingCalculatorMessage}
        closeMenu={closeMenu}
        setCloseMenu={setCloseMenu}
        typeName="universe"
      >
        <UniversesMenu setCloseMenu={setCloseMenu} />
      </InlineSelect>
    </div>
  );
};

export default UniversesSelect;
